import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { PATHS } from '../../common/constants';
import Anchor from '../../components/Anchor';
import Auth from '../../layouts/Auth';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { forgotPassword } from '../../store/actions/auth';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import variables from "../../styles/includes/variables.scss";
import { Images } from '../../Tenants';
import Loader from '../../components/Loader';

const validEmailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;


class ForgotPassword extends React.Component {
  state = {
    email: '',
  };

  validateMail(){
    let email = this.state.email;
    let errors = {
      emailValid: false,
      emailValidation: false,
      }

      if (email.trim().length > 0) {
        errors.emailValid = false
      } else {
        toast.error('🚫 Please enter a valid email address.',{autoClose:12000,position:'top-center'})
        errors.emailValid = true;
      }
      if (validEmailRegex.test(email.toLowerCase())) {
        errors.emailValidation = false
      } else {
        toast.error(' 🚫 Please enter a valid email address.',{autoClose:12000,position:'top-center'})
        errors.emailValidation = true
      }
      if (!Object.values(errors).includes(true)) {
        this.props.forgotPassword(email,this.props.history);
      }

  }

  render() {
    return (
     <>
     {
      this.props.formLoader?<Loader center={true}/>:null
     }
      <Auth
        title="Forgot Password"
        backgroundImage={Images.signInImage}
        content={(
          <>
            <div className="sign-in">
              <form
                onSubmit={e => {
                  e.preventDefault();
                  this.validateMail()
                }}
              >
                <div className="sign-in__header">
                  <div className="sign-in__headline">
                    Forgot password
                  </div>
                </div>
                <Input
                  value={this.state.email}
                  onChange={e => this.setState({ email: e.target.value.trim() })}
                  label="Email Address"
                  required
                  block
                />
                <div className="sign-in__button">
                  <Button 
                    label="Forgot Password"
                    color="teal"
                    submit
                    block
                  />
                </div>
                <div className="sign-in__footer">
                  Remember your password?
                  {' '}
                  <Anchor
                    path={PATHS.AUTH_SIGN_IN}
                    label="Sign In"
                  />
                </div>
              </form>
            </div>
          </>
        )}
      />
     </>
    );
  }
}

const mapStateToProps = (state) => ({
  formLoader:state.formLoader,
});
const mapDispatchToProps = dispatch => bindActionCreators({
  forgotPassword
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
